import React, { useContext, useCallback } from 'react';
import { classnames, bem, use } from '../../lib';
import { TabContext } from './TabContext';
export const Tab = ({ children, className, name }) => {
    const { state, onTabClick, compact } = useContext(TabContext);
    const handleClick = useCallback(() => {
        onTabClick(name);
    }, [onTabClick, name]);
    if (state.searchTerm !== undefined)
        return null;
    const active = state.activeTab === name;
    return (React.createElement("div", { className: classnames(className, bem('tabs__tab', use(active, '--active'), use(compact, '--compact'))), onClick: handleClick }, children));
};
//# sourceMappingURL=Tab.js.map